<mbsc-dropcontainer class="flex flex-col h-full min-h-0">
  <div class="flex flex-col mt-2 px-2 pb-2 border-b shrink-0">
    <p class="font-light text-light text-sm">
      {{ absence().length }} Abwesenheiten
    </p>
  </div>
  <div class="flex flex-col flex-1 min-h-0 overflow-y-auto pb-2">
    @for (absence of absence(); track absence.id) {
      <div
        mbsc-draggable
        [dragData]="absence"
        class="mx-2 mt-2 cursor-grab active:cursor-grabbing"
      >
        <div class="p-0! border bg-surface rounded-md flex overflow-hidden!">
          <div class="min-w-2! bg-danger">&nbsp;</div>
          <div class="flex flex-col p-2">
            <span class="text-danger uppercase text-sm font-semibold">
              Abwesenheit {{ absence?.type }}
            </span>
            <span>{{ $safeNavigationMigration(absence?.label) | titlecase }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</mbsc-dropcontainer>
